import { useMemo } from "react";
import { Card } from "@/components/ui/card";
import { User, Handshake, Sparkles } from "lucide-react";
import { eur, canaleOf, isAcq } from "@/lib/constants";

export function RitrCanali({ ssd, progetti, settings }) {
  const d = useMemo(() => {
    const chiusi = ssd.filter((s) => isAcq(s, settings));
    const rev = (arr) => arr.reduce((a, s) => a + (s.ricavo || 0), 0);
    const privati = ssd.filter((s) => s.canale !== "partner" && canaleOf(s) === "privati");
    const partners = ssd.filter((s) => s.canale === "partner");
    const viaPartner = ssd.filter((s) => s.canale !== "partner" && s.partner_id && !s.progetto_id);
    const exp = ssd.filter((s) => s.progetto_id);
    const posti = progetti.reduce((a, p) => a + (p.posti || 0), 0);
    return [
      { k: "privati", icon: User, title: "Clienti Privati", main: chiusi.filter((s) => privati.includes(s)).length, mainL: "acquisiti", sub: `${privati.length} in pipeline`, rev: rev(chiusi.filter((s) => privati.includes(s))), tone: "text-sky-600 bg-sky-100 dark:bg-sky-500/15" },
      { k: "partner", icon: Handshake, title: "Partner", main: partners.filter((s) => isAcq(s, settings)).length, mainL: "accordi attivi", sub: `${partners.length} in trattativa · ${viaPartner.length} clienti portati`, rev: rev(chiusi.filter((s) => viaPartner.includes(s))), tone: "text-amber-600 bg-amber-100 dark:bg-amber-500/15" },
      { k: "experience", icon: Sparkles, title: "Portrait Experience", main: progetti.length, mainL: "experience", sub: `${chiusi.filter((s) => s.progetto_id).length}/${posti} posti venduti`, rev: rev(chiusi.filter((s) => exp.includes(s))), tone: "text-purple-600 bg-purple-100 dark:bg-purple-500/15" },
    ];
  }, [ssd, progetti, settings]);

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-testid="ritr-canali">
      {d.map(({ k, icon: Icon, title, main, mainL, sub, rev, tone }) => (
        <Card key={k} data-testid={`canale-card-${k}`} className="p-5 animate-fade-up">
          <div className="flex items-center gap-2 mb-3">
            <span className={`h-9 w-9 rounded-xl flex items-center justify-center ${tone}`}><Icon className="h-4.5 w-4.5" /></span>
            <span className="font-semibold text-slate-900 dark:text-white">{title}</span>
          </div>
          <div className="flex items-end gap-2">
            <span className="text-3xl font-extrabold tabular-nums text-slate-900 dark:text-white">{main}</span>
            <span className="text-sm text-slate-500 mb-1">{mainL}</span>
          </div>
          <div className="text-xs text-slate-400 mt-1">{sub}</div>
          <div className="mt-3 pt-3 border-t border-slate-100 dark:border-slate-800 text-sm text-slate-500">Ricavi: <b className="text-primary tabular-nums">{eur(rev)}</b></div>
        </Card>
      ))}
    </div>
  );
}
